import { prettifyInlineJsonString } from "@/utils";

async function checkTurnConnectivity(check, results){
    console.log(`${check.title} Check Started`);

	let reply = { isPassed: true, details: { [check.title]: {} } };

    // Only Relay Only results determine pass/fail — Full is informational
    const relayResults = results.filter((r) => r.domain && r.domain.includes("Relay Only"));
    const criticalResults = relayResults.length > 0 ? relayResults : results;

    for(let result of criticalResults){
        if(
            result.connectionStatus != "ok" ||
            result.dataStatus != "ok" ||
            result.messageStatus != "ok" ||
            result.status != "ok"
        ){
            reply.isPassed = false;
            reply.details[result.domain] = {};
        }

        if(result.status != "ok"){
            reply.details[result.domain].status = result.status;
        }
        if(result.connectionStatus != "ok"){
            reply.details[result.domain].connectionStatus = result.connectionStatus;
        }
        if(result.messageStatus != "ok"){
            reply.details[result.domain].messageStatus = result.messageStatus;
        }
        if(result.dataStatus != "ok"){
            reply.details[result.domain].dataStatus = result.dataStatus;
        }
    }

    if(reply.isPassed){
        reply.details = `${check.title}: Working properly.`;
    }
    else {
        reply.details = `${check.title}: Not working properly: ${prettifyInlineJsonString(JSON.stringify(reply.details))}`;
    }

    return reply;
};

export default checkTurnConnectivity;